module.exports = __webpack_public_path__ + "img/header-weddingRingsGayLesbianCouples.92abbb8.jpg";